import { Avatar, AvatarProps } from '@mui/material';

interface Props extends Omit<AvatarProps, 'children'> {
  username: string;
  size?: 'small' | 'medium' | 'large';
}

const sizeMap = {
  small: 24,
  medium: 32,
  large: 40,
};

export const UserAvatar = ({ username, size = 'medium', sx, ...props }: Props): React.JSX.Element => {
  const initial = username?.[0]?.toUpperCase() ?? '?';
  const dimension = sizeMap[size];

  return (
    <Avatar
      sx={{
        bgcolor: 'secondary.main',
        width: dimension,
        height: dimension,
        fontSize: dimension * 0.5,
        fontWeight: 600,
        opacity: 0.7,
        ...sx,
      }}
      {...props}
    >
      {initial}
    </Avatar>
  );
};
